import { UploadStatus } from './interface'

/**
 * 是否上传成功
 */
export const isSuccessful = (status?: UploadStatus) => {
  return status === 'done'
}

/**
 * 是否上传失败
 */
export const isFailed = (status?: UploadStatus) => {
  return status === 'error'
}
/**
 * 是否正在上传
 */
export const isUploading = (status?: UploadStatus) => {
  return status === 'uploading'
}
